module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.needUpdate) ? _c('div', {
    staticClass: "update-mask"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "updateBrow"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h4', [_vm._v("你的浏览器版本太低啦，为了账户安全请使用Chrome浏览器")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chrome"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Google Chrome")]), _vm._v(" "), _c('span', {
    staticClass: "advantage"
  }, [_vm._v("安全")]), _vm._v(" "), _c('span', {
    staticClass: "advantage"
  }, [_vm._v("兼容性好")]), _vm._v(" "), _c('span', {
    staticClass: "advantage"
  }, [_vm._v("简洁高效")]), _vm._v(" "), _c('span', {
    staticClass: "advantage"
  }, [_vm._v("速度快")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/imgs/portal/home/Chrome_58.0.3029.110_Setup.exe",
      "id": "download",
      "title": ""
    }
  }, [_vm._v("下载正版")]), _vm._v(" "), _c('span', {
    staticClass: "suggest"
  }, [_c('span', {
    staticClass: "warn"
  }, [_vm._v("!")]), _vm._v("建议设为默认浏览器")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('p', [_vm._v("群星温馨提示：使用低版本浏览器有哪些坏处呢？")]), _vm._v(" "), _c('div', {
    staticClass: "disadvantage"
  }, [_c('div', {
    attrs: {
      "id": "safe"
    }
  }), _vm._v(" "), _c('p', [_vm._v("安全漏洞")]), _vm._v(" "), _c('span', [_vm._v("威胁账户安全")])]), _vm._v(" "), _c('div', {
    staticClass: "disadvantage"
  }, [_c('div', {
    attrs: {
      "id": "match"
    }
  }), _vm._v(" "), _c('p', [_vm._v("不兼容")]), _vm._v(" "), _c('span', [_vm._v("页面内容显示不全")])]), _vm._v(" "), _c('div', {
    staticClass: "disadvantage"
  }, [_c('div', {
    attrs: {
      "id": "pc"
    }
  }), _vm._v(" "), _c('p', [_vm._v("体验差")]), _vm._v(" "), _c('span', [_vm._v("界面排列错乱")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-62e088be"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/UpdateModal.vue
// module id = 289
// module chunks = 25 26